
import { Vue, Component } from 'vue-property-decorator';
import { ServerRepositoryInterface } from '@/services/Server/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddServerFrom from '@/services/Server/forms/AddServerFrom';
import { AxiosError } from 'axios';
import ServerTypeServicesAdditionDialog from '@/views/pages/server/ServerTypeServicesAdditionDialog.vue';
import PageHeader from '@/components/layout/PageHeader.vue';

@Component({
  components: {
    ServerTypeServicesAdditionDialog,
    PageHeader,
  },
  inject: ['serverRepository'],
})
export default class AddServer extends Vue {
  public readonly serverRepository!: ServerRepositoryInterface;

  public form: WPXFormValue<AddServerFrom> = new WPXFormValue(AddServerFrom);

  public serverTypes: string[] = [];

  public servicesAdditionDialog = '';

  public async created(): Promise<void> {
    this.serverTypes = await this.serverRepository.getServerTypes();
  }

  public async getServerTypeServices(): Promise<void> {
    this.form.data.availableServices = await this.serverRepository.getServerTypeServices(this.form.data.type);
  }

  public async onServicesSelected(newServicesJson: string): Promise<void> {
    const selection = JSON.parse(newServicesJson) as string[];
    await this.addServerTypeServices(selection);
  }

  public async addServerTypeServices(newServices: string[]): Promise<void> {
    try {
      this.form.data.availableServices = await this.serverRepository.addServerTypeServices(this.form.data.type, { services: newServices });
    } catch (err) {
      this.handleError(err);
    }
  }

  public async addServer(): Promise<void> {
    try {
      await this.serverRepository.addServer({
        hostname: this.form.data.hostname,
        type: this.form.data.type,
        services: this.form.data.services,
        config: {
          ips: this.form.data.config.ips,
          dns_ip: this.form.data.config.dns_ip,
        },
      });

      this.$successDialog.show(`Server ${this.form.data.hostname} has been added`);
      await this.$router.push({ name: 'server_all' });
    } catch (e) {
      this.$errorDialog.show((e as AxiosError)?.response?.data?.message || (e as Error).message);
    }
  }

  private handleError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }

  public async showServerTypeServicesAdditionDialog(): Promise<void> {
    this.servicesAdditionDialog = 'server-type-services-addition-dialog';
  }

  public async destroyDialog(): Promise<void> {
    this.servicesAdditionDialog = '';
  }
}
